/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "aa697723dd1f0e5e09b821922f67d99ecb6ff201";
